import api from "../../services/api";

const path = `${process.env.REACT_APP_API_PLUG}integracao/v2/bigdata`;

export async function findByCnpjInBigData(cnpj = "") {
  return api.get(`${path}/company/${cnpj.replace(/[^0-9]+/g, "")}`);
}

export async function findByPostalCodeInBigData(postalCode = "") {
  return api.get(`${path}/postalcode/${postalCode}`);
}

export async function findByCpfInBigData(cpf = "", birthDate = null) {
  return api.get(
    `${path}/person/${cpf.replace(/[^0-9]+/g, "")}${
      birthDate ? `?birthDate=${birthDate}` : ""
    }`
  );
}
